import React, { useEffect, useState } from 'react'
import { Container, Row, Col, OverlayTrigger, Tooltip, Button, Modal } from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link } from 'react-router-dom'
import { useGetForwarderListMutation, useDeleteForwarderMutation } from '../../../api/forwardersAPISlices'
import CustomPagination from '../../../components/utility/CustomPagination'
import Toaster from '../../../components/utility/Toaster'

const columns = [
    { label: "ID", key: "id" },
    { label: "Forwarding URL", key: "forwarding_url" },
    { label: "Forward From URL", key: "forward_url" },
    { label: "Created At", key: "created_at" },
    { label: "Action", key: "action" }
]

const ForwardersList = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [forwarders, setForwarders] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedForwarder, setSelectedForwarder] = useState(null);

    const [showToster, setShowToster] = useState(false);
    const [tosterMassage, setTosterMassage] = useState('');
    const [tosterStatus, setTosterStatus] = useState('');

    const [getForwarderList] = useGetForwarderListMutation();
    const [deleteForwarder] = useDeleteForwarderMutation();

    const token = JSON.parse(localStorage.getItem("token"));

    const getForwardersData = async () => {
        setIsLoading(true)
        await getForwarderList({ token, currentPage })
            .unwrap()
            .then((res) => {
                setForwarders(res)
                setIsLoading(false)
            })
            .catch((error) => {
                setShowToster(true)
                setTosterMassage(error?.data?.message || 'Error loading forwarders')
                setTosterStatus('error')
                setIsLoading(false)
            })
    }

    useEffect(() => {
        getForwardersData()
    }, [currentPage])

    const onPageChange = (page) => {
        setCurrentPage(page);
    };

    const handleDeleteClick = (forwarder) => {
        setSelectedForwarder(forwarder);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        await deleteForwarder({ forwarderId: selectedForwarder.id, token })
            .unwrap()
            .then((res) => {
                setShowDeleteModal(false);
                setShowToster(true)
                setTosterMassage('Forwarder deleted successfully')
                setTosterStatus('success')
                getForwardersData();
            })
            .catch((error) => {
                setShowDeleteModal(false);
                setShowToster(true)
                setTosterMassage(error?.data?.message || 'Error deleting forwarder')
                setTosterStatus('error')
            })
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        setShowToster(true)
        setTosterMassage('Copied to clipboard')
        setTosterStatus('success')
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString();
    };

    return (
        <>
            <Container fluid>
                <Row>
                    <Col lg="12">
                        <div className="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-4">
                            <div className="d-flex align-items-center justify-content-between">
                                <h4 className="font-weight-bold">Lead Forwarders</h4>
                            </div>
                            <div className="create-workform">
                                <div className="d-flex flex-wrap align-items-center justify-content-between">
                                    <div className="modal-product-search d-flex">
                                        <Link to="/forwarders-add" className="btn btn-primary position-relative d-flex align-items-center justify-content-between">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                            </svg>
                                            Add Forwarder
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {isLoading ?
                            (<div className='text-center mt-5 pt-5'>
                                <div className="spinner-border text-warning mr-2" role="status">
                                    <span className="visually-hidden"></span>
                                </div>
                            </div>)
                            : forwarders?.data?.length > 0 ?
                                <>
                                    <Row>
                                        <Col lg="12">
                                            <Card className="card-block card-stretch border-back">
                                                <Card.Body className="p-0">
                                                    <div className="table-responsive">
                                                        <table className="table data-table mb-0">
                                                            <thead className="table-color-heading">
                                                                <tr className="text-center">
                                                                    {columns.map((col, i) => (
                                                                        <th key={i} scope="col">
                                                                            {col.label}
                                                                        </th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {forwarders?.data?.map((row, index) => (
                                                                    <tr key={index} className="white-space-no-wrap">
                                                                        {columns.map((col) => (
                                                                            <td className='text-center' key={col.key}>
                                                                                {col?.key === 'action' ?
                                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>} >
                                                                                            <Link to={`/forwarders-edit/${row?.id}`}>
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="text-secondary mx-2" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                                                </svg>
                                                                                            </Link>
                                                                                        </OverlayTrigger>
                                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>} >
                                                                                            <button
                                                                                                className="btn btn-link p-0"
                                                                                                onClick={() => handleDeleteClick(row)}
                                                                                            >
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="text-danger mx-2" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                                                </svg>
                                                                                            </button>
                                                                                        </OverlayTrigger>
                                                                                    </div>
                                                                                    : col?.key === 'forward_url' ?
                                                                                        <div className="d-flex align-items-center justify-content-center">
                                                                                            <code className="mr-2" style={{ fontSize: '11px' }} title={row?.forward_url}>
                                                                                                {(() => {
                                                                                                    const url = row?.forward_url || '';
                                                                                                    if (url.length > 50) {
                                                                                                        return `${url.substring(0, 25)}...${url.substring(url.length - 20)}`;
                                                                                                    }
                                                                                                    return url;
                                                                                                })()}
                                                                                            </code>
                                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>Copy URL</Tooltip>} >
                                                                                                <button
                                                                                                    className="btn btn-link p-0"
                                                                                                    onClick={() => copyToClipboard(row?.forward_url)}
                                                                                                >
                                                                                                    <svg xmlns="http://www.w3.org/2000/svg" className="text-primary" width="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                                                                                    </svg>
                                                                                                </button>
                                                                                            </OverlayTrigger>
                                                                                        </div>
                                                                                    : col?.key === 'forwarding_url' ?
                                                                                        <div style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis' }} title={row?.forwarding_url}>
                                                                                            {row?.forwarding_url}
                                                                                        </div>
                                                                                    : col?.key === 'created_at' ?
                                                                                        formatDate(row?.created_at)
                                                                                    : row?.[col?.key] || ''
                                                                                }
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg="12" className='text-center'>
                                            <CustomPagination
                                                current_page={currentPage}
                                                last_page={forwarders?.meta?.last_page}
                                                onPageChange={onPageChange}
                                            />
                                        </Col>
                                    </Row>
                                </> :
                                <div className='pt-5 mt-5 mb-5 text-center'>
                                    No forwarders found
                                </div>
                        }
                    </Col>
                </Row>
            </Container>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this forwarder?
                    <div className="mt-3">
                        <strong>URL:</strong> {selectedForwarder?.forwarding_url}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteConfirm}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>

            <Toaster status={tosterStatus} message={tosterMassage} show={showToster} setShow={setShowToster} />
        </>
    )
}

export default ForwardersList;
